module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Bold-d0d14e8484479546f8c5cd2ae792494c.eot";